import _get from 'lodash/get';
import _map from 'lodash/map';
import _difference from 'lodash/difference';
import { UseBulkSelectResult } from '@lib/hooks/useTableItemsBulkSelect';
import { BaseItem } from '@lib/components/Table/types';

export interface FetchIdsResponse<T> {
  data?: {
    data: {
      collection: T[];
    };
  };
}

type Args<T extends BaseItem> = {
  fetchIds?: () => Promise<FetchIdsResponse<unknown>>;
  useBulkSelectResult?: UseBulkSelectResult<T>;
};

export default function getAllTableItemsIds<T extends BaseItem>({
  fetchIds,
  useBulkSelectResult,
}: Args<T>) {
  const { unselectedTableItems, isAllTableItemsSelected } =
    useBulkSelectResult || {};
  if (!fetchIds) return undefined;
  return fetchIds().then((res) => {
    const collectionIds = _get(res, 'data.data.collection', []);
    const allIds = _map(collectionIds, 'id');
    if (
      allIds?.length &&
      isAllTableItemsSelected &&
      unselectedTableItems?.length
    ) {
      const unselectedIds = _map(unselectedTableItems, 'id');
      return _difference(allIds, unselectedIds);
    }
    return allIds;
  });
}
